<form [formGroup]="equipmentInventoryForm" class="form was-validated">
  <ix-typography format="h3">Assets Inventory</ix-typography>
  <div class="container">
    <div class="column">
      <ix-typography format="h4">Automation Production Systems</ix-typography>
      <ix-layout-grid class="layout-grid-form" gap="12">
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-engineeringstation" aria-describedby="tooltip-engineeringstation"
              >Engineering Station</label
            >
            <ix-tooltip id="tooltip-engineeringstation" for=".tooltip-engineeringstation">{{
              equipmentInventoryForm.controls[fields.ENGINEERING_STATION_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.ENGINEERING_STATION"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label
              class="tooltip-OSServersincluding_BatchandRoutecontrol"
              aria-describedby="tooltip-OSServersincluding_BatchandRoutecontrol"
              >OS Servers including (Batch and Route control)</label
            >
            <ix-tooltip
              id="tooltip-OSServersincluding_BatchandRoutecontrol"
              for=".tooltip-OSServersincluding_BatchandRoutecontrol"
              >{{ equipmentInventoryForm.controls[fields.OS_SERVERS_BATCH_ROUTE_CONTROL_TOOLTIP].value }}</ix-tooltip
            >
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.OS_SERVERS_BATCH_ROUTE_CONTROL"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-OSClients" aria-describedby="tooltip-OSClients">OS Clients</label>
            <ix-tooltip id="tooltip-OSClients" for=".tooltip-OSClients">{{
              equipmentInventoryForm.controls[fields.OS_CLIENTS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.OS_CLIENTS"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-Dataclients" aria-describedby="tooltip-Dataclients">Data Clients</label>
            <ix-tooltip id="tooltip-Dataclients" for=".tooltip-Dataclients">{{
              equipmentInventoryForm.controls[fields.DATA_CLIENTS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.DATA_CLIENTS"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-OtherProductionsystems" aria-describedby="tooltip-OtherProductionsystems"
              >Other Production systems</label
            >
            <ix-tooltip id="tooltip-OtherProductionsystems" for=".tooltip-OtherProductionsystems">{{
              equipmentInventoryForm.controls[fields.OTHER_PRODUCTION_SYSTEMS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.OTHER_PRODUCTION_SYSTEMS"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
      </ix-layout-grid>

      <br />

      <ix-typography format="h4">HyperVisor Hardware</ix-typography>
      <ix-layout-grid class="layout-grid-form" gap="12">
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-Hosts" aria-describedby="tooltip-Hosts">Hosts</label>
            <ix-tooltip id="tooltip-Hosts" for=".tooltip-Hosts">{{
              equipmentInventoryForm.controls[fields.HOSTS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.HOSTS"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>

        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-iDMZhost" aria-describedby="tooltip-iDMZhost">IDMZ Host</label>
            <ix-tooltip id="tooltip-iDMZhost" for=".tooltip-iDMZhost">{{
              equipmentInventoryForm.controls[fields.IDMZ_HOST_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.IDMZ_HOST"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-coreswitches" aria-describedby="tooltip-coreswitches">Core Switches</label>
            <ix-tooltip id="tooltip-coreswitches" for=".tooltip-coreswitches">{{
              equipmentInventoryForm.controls[fields.CORE_SWITCHES_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.CORE_SWITCHES"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-firewalls" aria-describedby="tooltip-firewalls">Firewalls</label>
            <ix-tooltip id="tooltip-firewalls" for=".tooltip-firewalls">{{
              equipmentInventoryForm.controls[fields.FIREWALLS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.FIREWALLS"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-SIDSIBR" aria-describedby="tooltip-SIDSIBR">SIDSI B&R</label>
            <ix-tooltip id="tooltip-SIDSIBR" for=".tooltip-SIDSIBR">{{
              equipmentInventoryForm.controls[fields.SIDSIB_AND_R_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.SIDSIB_AND_R"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-PH" aria-describedby="tooltip-PH">PH</label>
            <ix-tooltip id="tooltip-PH" for=".tooltip-PH">{{
              equipmentInventoryForm.controls[fields.PH_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.PH"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-UPS" aria-describedby="tooltip-UPS">UPS</label>
            <ix-tooltip id="tooltip-UPS" for=".tooltip-UPS">{{
              equipmentInventoryForm.controls[fields.UPS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.UPS"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-NAS" aria-describedby="tooltip-NAS">NAS</label>
            <ix-tooltip id="tooltip-NAS" for=".tooltip-NAS">{{
              equipmentInventoryForm.controls[fields.NAS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.NAS"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-USBconnectorHUB" aria-describedby="tooltip-USBconnectorHUB">USB connector HUB</label>
            <ix-tooltip id="tooltip-USBconnectorHUB" for=".tooltip-USBconnectorHUB">{{
              equipmentInventoryForm.controls[fields.USB_CONNECTOR_HUB_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.USB_CONNECTOR_HUB"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-Thinclients" aria-describedby="tooltip-Thinclients">Thin Clients</label>
            <ix-tooltip id="tooltip-Thinclients" for=".tooltip-Thinclients">{{
              equipmentInventoryForm.controls[fields.THIN_CLIENTS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.THIN_CLIENTS"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
      </ix-layout-grid>
    </div>

    <div class="column">
      <ix-typography format="h4">Supporting systems</ix-typography>
      <ix-layout-grid class="layout-grid-form" gap="12">
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-DataExchangeServer" aria-describedby="tooltip-DataExchangeServer"
              >Data Exchange Server</label
            >
            <ix-tooltip id="tooltip-DataExchangeServer" for=".tooltip-DataExchangeServer">{{
              equipmentInventoryForm.controls[fields.DATA_EXCHANGE_SERVER_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.DATA_EXCHANGE_SERVER"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-Jumphost" aria-describedby="tooltip-Jumphost">Jumphost</label>
            <ix-tooltip id="tooltip-Jumphost" for=".tooltip-Jumphost">{{
              equipmentInventoryForm.controls[fields.JUMPHOST_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.JUMPHOST"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-Domain" aria-describedby="tooltip-Domain">Domain</label>
            <ix-tooltip id="tooltip-Domain" for=".tooltip-Domain">{{
              equipmentInventoryForm.controls[fields.DOMAIN_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.DOMAIN"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-NetworkMonitorServer" aria-describedby="tooltip-NetworkMonitorServer"
              >Network Monitor Server</label
            >
            <ix-tooltip id="tooltip-NetworkMonitorServer" for=".tooltip-NetworkMonitorServer">{{
              equipmentInventoryForm.controls[fields.NETWORK_MONITOR_SERVER_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.NETWORK_MONITOR_SERVER"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-Management" aria-describedby="tooltip-Management">Management</label>
            <ix-tooltip id="tooltip-Management" for=".tooltip-Management">{{
              equipmentInventoryForm.controls[fields.MANAGEMENT_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.MANAGEMENT"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-DNS" aria-describedby="tooltip-DNS">DNS</label>
            <ix-tooltip id="tooltip-DNS" for=".tooltip-DNS">{{
              equipmentInventoryForm.controls[fields.DNS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.DNS"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-EndpointProtection" aria-describedby="tooltip-EndpointProtection"
              >Endpoint Protection</label
            >
            <ix-tooltip id="tooltip-EndpointProtection" for=".tooltip-EndpointProtection">{{
              equipmentInventoryForm.controls[fields.ENDPOINT_PROTECTION_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.ENDPOINT_PROTECTION"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-InformationServer" aria-describedby="tooltip-InformationServer"
              >Information Server</label
            >
            <ix-tooltip id="tooltip-InformationServer" for=".tooltip-InformationServer">{{
              equipmentInventoryForm.controls[fields.INFORMATION_SERVER_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.INFORMATION_SERVER"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-UpdateServer_WSUS" aria-describedby="tooltip-UpdateServer_WSUS"
              >Update Server (WSUS)</label
            >
            <ix-tooltip id="tooltip-UpdateServer_WSUS" for=".tooltip-UpdateServer_WSUS">{{
              equipmentInventoryForm.controls[fields.UPDATE_SERVER_WSUS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.UPDATE_SERVER_WSUS"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-OtherWindows" aria-describedby="tooltip-OtherWindows">Other Windows</label>
            <ix-tooltip id="tooltip-OtherWindows" for=".tooltip-OtherWindows">{{
              equipmentInventoryForm.controls[fields.OTHER_WINDOWS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.OTHER_WINDOWS"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-OtherOS" aria-describedby="tooltip-OtherOS">Other OS</label>
            <ix-tooltip id="tooltip-OtherOS" for=".tooltip-OtherOS">{{
              equipmentInventoryForm.controls[fields.OTHER_OS_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.OTHER_OS"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
      </ix-layout-grid>

      <br />

      <ix-typography format="h4">Additional Hardware</ix-typography>
      <ix-layout-grid class="layout-grid-form" gap="12">
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-SwitchesPCN" aria-describedby="tooltip-SwitchesPCN">Switches PCN</label>
            <ix-tooltip id="tooltip-SwitchesPCN" for=".tooltip-SwitchesPCN">{{
              equipmentInventoryForm.controls[fields.SWITCHES_PCN_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.SWITCHES_PCN"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-SwitchesCSN" aria-describedby="tooltip-SwitchesCSN">Switches CSN</label>
            <ix-tooltip id="tooltip-SwitchesCSN" for=".tooltip-SwitchesCSN">{{
              equipmentInventoryForm.controls[fields.SWITCHES_CSN_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.SWITCHES_CSN"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        <ix-row>
          <ix-col size="6" size-sm="12">
            <label class="tooltip-SwitchesFSN" aria-describedby="tooltip-SwitchesFSN">Switches FSN</label>
            <ix-tooltip id="tooltip-SwitchesFSN" for=".tooltip-SwitchesFSN">{{
              equipmentInventoryForm.controls[fields.SWITCHES_FSN_TOOLTIP].value
            }}</ix-tooltip>
          </ix-col>
          <ix-col>
            <ix-number-input
              [formControlName]="fields.SWITCHES_FSN"
              pattern="[0-9]+"
              min="0"
              [invalidText]="validationFeedback.negativeInteger"
              showStepperButtons="true"
            ></ix-number-input>
          </ix-col>
        </ix-row>
        @if (equipmentInventoryForm.controls[fields.PLC_AS_VISIBLE].value === '1') {
          <ix-row>
            <ix-col size="6" size-sm="12">
              <label class="tooltip-PLC-AS" aria-describedby="tooltip-PLC-AS">PLC-AS</label>
              <ix-tooltip id="tooltip-PLC-AS" for=".tooltip-PLC-AS">{{
                equipmentInventoryForm.controls[fields.PLC_AS_TOOLTIP].value
              }}</ix-tooltip>
            </ix-col>
            <ix-col>
              <ix-number-input
                [formControlName]="fields.PLC_AS"
                pattern="[0-9]+"
                min="0"
                [invalidText]="validationFeedback.negativeInteger"
                showStepperButtons="true"
              ></ix-number-input>
            </ix-col>
          </ix-row>
        }
      </ix-layout-grid>
    </div>
  </div>

  <div class="button-container">
    <ix-button variant="subtle-primary" class="m-1 back-button" (click)="stepBack()">Back</ix-button>
    <ix-button variant="primary" class="next-button" (click)="nextStep()">Next</ix-button>
  </div>
</form>
